import React from "react";
import { TabBar, Space } from "@thenounproject/lingo-core";

import ModalHeader from "../../../../app/_components/ModalHeader";
import InsightsKitViewTab from "./InsightsKitViewTab";
import InsightsKitAssetsTab from "./InsightsKitAssetsTab";
import InsightsKitPortalTab from "./InsightsKitPortalTab";
import { InsightsPageWrapper } from "../ReportElements";

type Props = {
  kitId: string;
  kitName: string;
  space: Space;
};

enum Tab {
  views = "views",
  assets = "assets",
  portals = "portals",
}

const InsightsKitModal = ({ kitId, kitName, space }: Props) => {
  const [selectedTab, setSelectedTab] = React.useState<string>(Tab.views);

  function renderTab() {
    switch (selectedTab) {
      case Tab.views:
        return <InsightsKitViewTab kitId={kitId} space={space} />;
      case Tab.assets:
        return <InsightsKitAssetsTab kitId={kitId} space={space} />;
      case Tab.portals:
        return <InsightsKitPortalTab kitId={kitId} space={space} />;
      default:
        return null;
    }
  }

  return (
    <>
      <ModalHeader title={kitName || "Kit"}>
        <TabBar>
          <TabBar.Item
            text="Views"
            selected={selectedTab === Tab.views}
            onClick={() => setSelectedTab(Tab.views)}
          />
          <TabBar.Item
            text="Assets"
            selected={selectedTab === Tab.assets}
            onClick={() => setSelectedTab(Tab.assets)}
          />
          <TabBar.Item
            text="Portals"
            selected={selectedTab === Tab.portals}
            onClick={() => setSelectedTab(Tab.portals)}
          />
        </TabBar>
      </ModalHeader>
      <InsightsPageWrapper>{renderTab()}</InsightsPageWrapper>
    </>
  );
};

export default InsightsKitModal;
